import React from 'react';

import { Column } from "components/Layout/Grid";
import Text from "components/Text";
import { IOrderItem } from "models/Order";

import * as Styled from './styles';

interface OrderItemsProps {
  items: IOrderItem[];
}

export const OrderItems: React.FC<OrderItemsProps> = ({ items }) => (
  <Column className="mt-5">
    <Text className="color-blue-gray" weight="bold" size={18}>
      Itens do Pedido
    </Text>
    <Styled.WrapperItems>
      {items.map((item) => (
        <Column className="mt-3 grid-gap-1" key={item?.code}>
          <Text className="color-blue-gray" weight="bold" size={16}>
            Produto: <strong>{item?.name}</strong>
          </Text>
          <Text className="color-blue-gray" weight="bold" size={16}>
            Lote: <strong>{item?.lot}</strong>
          </Text>
        </Column>
      ))}
    </Styled.WrapperItems>
  </Column>
);